module.exports = __webpack_public_path__ + "media/Blob 6 Joins.2e54f9a8.mp3";